import { gql } from 'apollo-angular';
import { ADDRESS_FIELDS_FRAGMENT } from "./address-fragment-definition";
import { DISCOUNT_GROUP_RELATION_DOCUMENT_BASE_FRAGMENT } from "./discount-group.definition";
import { DELETION_RESPONSE_FRAGMENT } from './system-definition';

export const DISCOUNT_GROUP_CUSTOMER_RELATION_FRAGMENT = gql`
fragment DiscountGroupCustomerRelation on DiscountGroupCustomerRelation {
    ...DiscountGroupRelationDocumentBase
    customerId
    customer {
        ...AddressFields
    }
}
${DISCOUNT_GROUP_RELATION_DOCUMENT_BASE_FRAGMENT}
${ADDRESS_FIELDS_FRAGMENT}
`;

export const GET_DISCOUNT_GROUP_CUSTOMER_RELATIONS = gql`
query GetDiscountGroupCustomerRelations($input:DiscountGroupCustomerRelationSearchInput) {
    getDiscountGroupCustomerRelations(input: $input) {
        totalItems
        items {
            ...DiscountGroupCustomerRelation
        }
    }
}
${DISCOUNT_GROUP_CUSTOMER_RELATION_FRAGMENT}
`;

export const GET_DISCOUNT_GROUP_CUSTOMER_RELATION = gql`
query GetDiscountGroupCustomerRelation($id:String!) {
    getDiscountGroupCustomerRelation(id: $id) {
        ...DiscountGroupCustomerRelation
    }
}
${DISCOUNT_GROUP_CUSTOMER_RELATION_FRAGMENT}
`;


export const SAVE_DISCOUNT_GROUP_CUSTOMER_RELATION = gql`
mutation SaveDiscountGroupCustomerRelation($input: DiscountGroupCustomerRelationInput!) {
    saveDiscountGroupCustomerRelation(input: $input) {
        ... DiscountGroupCustomerRelation
    }
}
${DISCOUNT_GROUP_CUSTOMER_RELATION_FRAGMENT}
`;

export const DELETE_DISCOUNT_GROUP_CUSTOMER_RELATION = gql`
mutation DeleteDiscountGroupCustomerRelation($id: String!) {
    deleteDiscountGroupCustomerRelation(id: $id) {
        ... DeletionResponse
    }
}
${DELETION_RESPONSE_FRAGMENT}
`;